import { render, staticRenderFns } from "./BtnCompare.vue?vue&type=template&id=f7a5ea44&"
import script from "./BtnCompare.vue?vue&type=script&lang=js&"
export * from "./BtnCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports